import React from 'react';
import './index.scss';
export interface FileItem {
  fileName: string;
  downloadUrl: string;
  enable: boolean;
}
export interface DownloadListProps {
  downloadList?: FileItem[];
}
const DownloadList = (props: DownloadListProps) => {
  const { downloadList } = props;
  return (
    <ul className='file-list'>
      {downloadList ? (
        downloadList.map((item: FileItem, index: number) => (
          <li key={item.fileName + index}>
            {item.enable ? (
              <>
                <a href={item.downloadUrl} download={item.fileName}>
                  {item.fileName}
                </a>
                <i className='enable-btn'></i>
              </>
            ) : (
              <i className='disabled'>{item.fileName}</i>
            )}
          </li>
        ))
      ) : (
        <div style={{ textAlign: 'center' }}>暂无可下载文件！</div>
      )}
    </ul>
  );
};

export default React.memo(DownloadList);
